import { createSlice } from "@reduxjs/toolkit";
import {
  registerStudent,
  registerTeacher,
  getClassesList,
  getTopicsList,
  getGroupsList,
  getBotAccessList,
  sendWelcomeTemplate,
} from "./studentThunk";

const initialState = {
  student: null,
  loading: false,
  error: null,
  classes: [],
  subjects: [],
  class_id: "",
  subject_id: "",
  topicInfo: [],
  showPopUp: false,
  contentInPopUp: [],
  category: "",
  groups: [],
  group_id: "",
  botAccess: [],
};

const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    clearStudentState(state) {
      state.student = null;
      state.error = null;
    },
    setState(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerStudent.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerStudent.fulfilled, (state, action) => {
        state.loading = false;
        state.student = action.payload;
      })
      .addCase(registerStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(registerTeacher.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerTeacher.fulfilled, (state, action) => {
        state.loading = false;
        state.student = action.payload;
      })
      .addCase(registerTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getClassesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClassesList.fulfilled, (state, action) => {
        state.loading = false;
        state.classes = action.payload?.data || [];
      })
      .addCase(getClassesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTopicsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopicsList.fulfilled, (state, action) => {
        state.loading = false;
        state.topicInfo = action.payload?.data || [];
      })
      .addCase(getTopicsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getGroupsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGroupsList.fulfilled, (state, action) => {
        state.loading = false;
        state.groups = action.payload?.data || [];
      })
      .addCase(getGroupsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getBotAccessList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBotAccessList.fulfilled, (state, action) => {
        state.loading = false;
        state.botAccess = action.payload?.mappedStatus || [];
      })
      .addCase(getBotAccessList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendWelcomeTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendWelcomeTemplate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(sendWelcomeTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearStudentState, setState } = studentSlice.actions;
export default studentSlice.reducer;
